import { TeamTabMenu } from '@/types/menu';

export function getCurrentTeamTabMenu(pathname: string): TeamTabMenu | undefined {
  // HOMEかどうか
  const regex_home = /^\/teams\/[^/]+\/?$/;
  if (regex_home.test(pathname)) {
    return 'HOME';
  }

  // チームノートかどうか
  const regex_teams_notes = /^\/teams\/[^/]+\/notes\/?$/;
  if (regex_teams_notes.test(pathname)) {
    return 'TEAM_NOTE';
  }

  // チームメンバーの目標一覧かどうか
  const regex_goals = /^\/teams\/[^/]+\/goals\/?$/;
  if (regex_goals.test(pathname)) {
    return 'GOALS';
  }

  // 所属メンバーかどうか
  const regex_teams_members = /^\/teams\/[^/]+\/members\/?$/;

  if (regex_teams_members.test(pathname)) {
    return 'MEMBER';
  }

  // 所属メンバー検索・管理かどうか
  const regex_member_configs = /^\/teams\/[^/]+\/members\/settings\/?$/;
  if (regex_member_configs.test(pathname)) {
    return 'MEMBER_SETTINGS';
  }

  // チーム設定かどうか
  // const regex_teams_configs = /^\/teams\/[^/]+\/settings\/?$/
  // if (regex_teams_configs.test(pathname)) {
  //   return 'TEAM_SETTINGS';
  // }

  // MEMBER_CONFIG
  // const regex_member_configs = /^\/teams\/[^/]+\/members\/settings\/?$/
  // if (regex_member_configs.test(pathname)) {
  //   return 'MEMBER_SETTINGS';
  // }

  return undefined;
}
